module.exports = __webpack_public_path__ + "media/spa/flow_step_05-3b4cc6e5.svg";